<template>
    <div class="product-coverage-calculator-results">
        <div class="product-coverage-calculator-header">
            <h3 class="xs-title text-cod-gray">Your Results</h3>

            <button v-show="hasResults" type="button" @click.prevent="emitReset" class="btn product-selector-link circle-link" aria-label="Reset results">
                <span>Clear Results</span>
                <button class="btn btn-circle text-blue-stone">
                    <div class="relative">
                        <circle-button />
                        <figure>
                            <span class="inline-svg" style="padding-top: 100%">
                                <button-arrow />
                            </span>
                        </figure>
                    </div>
                </button>
            </button>
        </div>

        <template v-if="hasResults">
            <div>
                <h4>Treated Area (m&sup2;)</h4>
                <span v-if="results.area">{{ results.area }}</span>
            </div>

            <div v-for="(coverage, index) in info.coverage">
                <h4>{{ coverage.label }}</h4>
                <span>Coverage per litre (m&sup2;) {{ coverage.per_litre }}</span>
                <span v-if="coverage.per_litre">You will require approximately <strong>{{ calculateLitres(results.area, coverage.per_litre) }} litres</strong> of product.</span>
            </div>

            <div>
                <h4>Coverage advice/guidance</h4>
                <p v-html="info.comments" />
            </div>

            <a v-if="info.handle" :href="'/products/' + info.handle" class="product-result-link btn btn-tertiary"><span class="btn-text">Buy Now</span><figure class="btn-icon"><span class="inline-svg" style="padding-top: 100%;"><svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m5.608 10.705.795.795 5.5-5.5-5.5-5.5-.795.795L9.75 5.437H.096v1.125H9.75l-4.142 4.143Z" fill="currentColor"></path></svg></span></figure></a>
        </template>
        <template v-else>
            <p style="margin: 0">Please fill in your information to calculate your coverage.</p>
        </template>
    </div>
</template>
<script>
import { EventBus } from '~/event-bus.js'

export default {
    name: 'ProductCoverageCalculatorResults',
    computed: {
        results() {
            return this.$store.state.calculator.results
        },
        info() {
            return this.$store.state.calculator.info
        },
        hasResults() {
            return this.$store.state.calculator.has_results
        },
    },
    methods: {
        emitReset() {
            EventBus.$emit('reset', {})
        },
        calculateLitres(area, coverage) {
            return parseFloat(area / coverage).toFixed(1)
        }
    },
}
</script>
